import { render } from "./providerSurvey.vue?vue&type=template&id=12636090&scoped=true&ts=true"
import script from "./providerSurvey.vue?vue&type=script&lang=ts"
export * from "./providerSurvey.vue?vue&type=script&lang=ts"

import "./providerSurvey.vue?vue&type=style&index=0&id=12636090&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12636090"]])

export default __exports__